import { CuffaMeasurementUnitEnum } from 'common/enums';

export function getEnumValues(e: any): string[] {
  return Object.values(e).filter((value) => typeof value === 'string') as string[];
}

export function parseHasCertification(value: any): boolean | null {
  if (value === undefined || value === null) return null;
  if (typeof value === 'boolean') return value;
  if (typeof value === 'string') return value.toLowerCase() === 'true';
  if (typeof value === 'number') return value === 1;
  return null;
}

export function formatCurrencyInput(raw: string): string {
  // simple wrapper to keep formatting logic testable; original project
  // uses formatCurrency from utils/forms/cuffa_functions — keep name distinct
  return raw.replace(/[^0-9]/g, '');
}

export function defaultUnitForProduct(name: string, productionType: string, isProcessed: boolean, productType?: string): CuffaMeasurementUnitEnum[] {
  // Delegate to existing utility in project when available — fallback safe default
  return [CuffaMeasurementUnitEnum.QUILOGRAMAS];
}
